import React from 'react'
import ReactLoading from 'react-loading'

const Loader = (loadingInfo) => {
    return (
        <div className='w-screen h-screen bg-white fixed left-0 right-0 top-0 bottom-0 z-[1000] flex flex-col justify-center items-center gap-2'>
            <p className='text-sm text-custom-blue w-fit mx-auto'>Loading, please wait...</p>
            <ReactLoading type="spin" className='w-[150px] h-[150px]' color='#3e4095' /> 
        </div>
    )
}

export default Loader